import React from 'react';
import { Tooltip } from 'antd';

export default function CustomTooltip(props) {
  return <Tooltip {...props} />;
}
